



















import { Component, Prop, Vue } from 'vue-property-decorator';
import Supplier from '@/interfaces/Supplier';

@Component
export default class SupplierCard extends Vue {
  @Prop() private supplierInfo!: Supplier;

  @Prop() private supplierObject!: Supplier;

  @Prop() private dialogMode!: string;

  @Prop() private showDialog!: boolean;

  editSupplier(supplier: Supplier) {
    this.$emit('update:dialogMode', 'edit');
    this.$emit('update:showDialog', true);
    this.$emit('update:supplierObject', supplier);
  }
}
